import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SessionTimeout = ({ timeout = 30 * 60 * 1000 }) => { // default: 30 mins
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/"); // Redirect to login/home
  };

  useEffect(() => {
    const timer = setTimeout(logout, timeout);

    return () => clearTimeout(timer); // cleanup if component unmounts
  }, [timeout]);

  return null; // Nothing to render
};

export default SessionTimeout;
